(function(){
  /********************
   * Polyfill
   ********************/
  if (typeof CSS === 'undefined' || typeof CSS.escape !== 'function') {
    (function() {
      var cssEscape = function(value) {
        return String(value).replace(/[\0-\x1F\x7F]|^-?\d|^-$|[^\w-]/g, function(ch) {
          var hex = ch.charCodeAt(0).toString(16).toUpperCase();
          return "\\" + hex + " ";
        });
      };
      window.CSS = window.CSS || {};
      window.CSS.escape = cssEscape;
    })();
  }

  /********************
   * Desired props (ONLY when 25% Bundler discount is present)
   ********************/
  const BNDLR_PROPS = {
    itemprocode: 'SMILE25',
    itemprodisc: '25',
    itemprotype: 'percentage'
  };
  const OUR_KEYS = Object.keys(BNDLR_PROPS);

  /********************
   * UI helpers (unchanged)
   ********************/
  function getWidgetContainer(fromNode) {
    return (fromNode && fromNode.closest?.('.bndlr-container, .bundle-grid, .bndlr-sectioned-available-products'))
        || document.querySelector('.bndlr-container, .bundle-grid, .bndlr-sectioned-available-products')
        || document;
  }

  function waitForImages(root, selector, callback) {
    const images = (root || document).querySelectorAll(selector);
    let loaded = 0, total = images.length;
    if (!total) return callback();
    function inc(){ if (++loaded === total) callback(); }
    images.forEach(img => {
      if (img.complete || img.naturalHeight > 0) inc();
      else { img.addEventListener('load', inc, {once:true}); img.addEventListener('error', inc, {once:true}); }
    });
  }

  function matchHeights(scope) {
    const cards = (scope || document).querySelectorAll('.bndlr-product');
    let max = 0;
    cards.forEach(p => p.style.height = 'auto');
    cards.forEach(p => { max = Math.max(max, p.offsetHeight || 0); });
    cards.forEach(p => p.style.height = `${max}px`);
  }

  function matchTitleHeights(scope) {
    const titles = (scope || document).querySelectorAll('.bndlr-product-title');
    let max = 0;
    titles.forEach(t => t.style.minHeight = 'auto');
    titles.forEach(t => { max = Math.max(max, t.offsetHeight || 0); });
    titles.forEach(t => t.style.minHeight = `${max}px`);
  }

  function wireBundlePropsToButton(btn){
    if (!btn || btn.dataset.bundlePropsWired === '1') return;
    btn.dataset.bundlePropsWired = '1';
    btn.addEventListener('click', (ev)=>{
      if (btn.classList.contains('disabled') || btn.getAttribute('aria-disabled') === 'true') {
        ev.preventDefault(); ev.stopPropagation();
      }
    }, true);
  }

  function wireAllButtons(scope){
    (scope || document)
      .querySelectorAll('.bndlr-add-to-bundle, .bndlr-add-to-cart, [title="Add to bundle"], [title="Add to cart"]')
      .forEach(wireBundlePropsToButton);
  }

  function getHandleFromLink(a) {
    try {
      const url = new URL(a.href, location.origin);
      const parts = url.pathname.split('/').filter(Boolean);
      return (parts.pop() || '').replace(/\/+$/, '');
    } catch {
      const href = a.getAttribute('href') || '';
      const clean = href.split('?')[0].replace(/\/+$/, '');
      const parts = clean.split('/').filter(Boolean);
      return parts.pop() || '';
    }
  }

  /********************
   * STRICT sync: add props ONLY when line has ~25% discount; remove otherwise
   ********************/
  if (!window.__BNDLR_STRICT_PROP_SYNC) {
    window.__BNDLR_STRICT_PROP_SYNC = true;

    // compute discount percent from available fields; tolerate rounding
    function discountPercent(item){
      const orig = Number(item.original_line_price || 0);
      if (!orig) return 0;
      let disc = 0;

      // prefer direct numbers if present
      if (typeof item.total_discount === 'number') disc = Math.max(disc, item.total_discount);
      if (typeof item.line_level_total_discount === 'number') disc = Math.max(disc, item.line_level_total_discount);

      // allocations sum
      if (Array.isArray(item.line_level_discount_allocations)) {
        const allocSum = item.line_level_discount_allocations.reduce((s,a)=> s + (Number(a.amount)||0), 0);
        disc = Math.max(disc, allocSum);
      }

      // fallback from prices
      if (typeof item.original_line_price === 'number' && typeof item.line_price === 'number') {
        disc = Math.max(disc, item.original_line_price - item.line_price);
      }

      return (disc / orig) * 100;
    }

    function isTwentyFivePercent(item){
      const pct = discountPercent(item);
      // allow small rounding drift
      return Math.abs(pct - 25) <= 0.75;
    }

    function propsEqual(item){
      const p = item.properties || {};
      return OUR_KEYS.every(k => p[k] === BNDLR_PROPS[k]);
    }

    function stripOurProps(props){
      const out = {...(props || {})};
      OUR_KEYS.forEach(k => { delete out[k]; });
      return out;
    }

    let syncing = false, queued = false;
    function scheduleSync(delay=80){ if (syncing){ queued = true; return; } setTimeout(syncProps, delay); }

    async function changeLineProps(key, properties){
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, properties })
      });
    }

    async function syncProps(){
      if (syncing) return;
      syncing = true; queued = false;
      try {
        const cart = await fetch('/cart.js', { credentials:'same-origin' }).then(r => r.json());
        const ops = [];
        for (const item of cart.items || []) {
          const has25 = isTwentyFivePercent(item);
          const p = item.properties || {};

          if (has25) {
            if (!propsEqual(item)) {
              const merged = { ...p, ...BNDLR_PROPS };
              ops.push(changeLineProps(item.key, merged));
            }
          } else {
            if (OUR_KEYS.some(k => k in p)) {
              const cleaned = stripOurProps(p);
              ops.push(changeLineProps(item.key, cleaned));
            }
          }
        }
        if (ops.length) await Promise.allSettled(ops);
        if (ops.length) console.log('[Strict Prop Sync] adjusted', ops.length, 'line(s).');
      } catch(e){
        console.warn('[Strict Prop Sync] error', e);
      } finally {
        syncing = false;
        if (queued) setTimeout(syncProps, 80);
      }
    }

    // Triggers where discount state changes or items are added
    document.addEventListener('bundler:total_cart_values', () => scheduleSync(0));
    document.addEventListener('bndlr:bundle_added_to_cart', () => scheduleSync(0));
    document.addEventListener('product:added', () => scheduleSync(150));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scheduleSync(200));
    } else {
      scheduleSync(200);
    }

    // Cart UI/dom changes ⇒ light resync
    const mo = new MutationObserver(() => scheduleSync(400));
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /********************
   * Bundler widget UI (NO prop injection here)
   ********************/
  document.addEventListener('bundler:bundle_widget_created', function (e) {
    const widget = getWidgetContainer(e.target);

    const products = widget.querySelectorAll('.bndlr-product');
    const fetchPromises = [];

    products.forEach(el => {
      el.classList.add('loading');
      const productLink = el.querySelector('a');
      if (!productLink) return;

      const handle = getHandleFromLink(productLink);
      if (!handle) return;

      const fetchPromise = fetch('https://staging-shop.dolfinswimwear.com/api/2023-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '6cda9e96ea001c684d7c46dce023ef9e'
        },
        body: JSON.stringify({
          query: `
            query {
              productByHandle(handle: "${handle}") {
                title
                images(first: 1) { edges { node { url altText } } }
                metafield(namespace: "product", key: "ProductTitle") { value }
              }
            }
          `
        })
      })
      .then(res => res.json())
      .then(data => {
        const productData = data?.data?.productByHandle;
        if (!productData) return;

        const title = productData.metafield?.value || productData.title || 'Missing Title';
        const visibleTitle = el.querySelector('.bndlr-product-title');
        if (visibleTitle) visibleTitle.textContent = title;

        const imageUrl = productData.images?.edges?.[0]?.node?.url;
        if (imageUrl) {
          const imgWrapper = el.querySelector('.bndlr-product-image-url');
          if (imgWrapper) {
            imgWrapper.innerHTML = `<img src="${imageUrl}" alt="${title}" class="bndlr-product-image" width="300" height="400">`;
          }
        }

        // optional hidden title (prefixed so it won't show on cart)
        const hiddenTitle = document.createElement('input');
        hiddenTitle.type = 'hidden';
        const safeTitle = String(title).replace(/\]/g, ')');
        hiddenTitle.name = `properties[_${safeTitle}]`;
        hiddenTitle.value = ' ';
        el.appendChild(hiddenTitle);
      })
      .catch(err => console.error('GraphQL metafield fetch error:', err));

      fetchPromises.push(fetchPromise);
    });

    Promise.all(fetchPromises).then(() => {
      waitForImages(widget, '.bndlr-product img', () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            matchTitleHeights(widget);
            matchHeights(widget);
            wireAllButtons(widget);

            products.forEach(product => {
              product.classList.remove('loading');
              product.classList.add('ready');

              const select = product.querySelector('select.bndlr-select-variant');
              const addButton = product.querySelector('.bndlr-add-to-bundle, .bndlr-add-to-cart, [title="Add to bundle"], [title="Add to cart"]');
              if (!select || select.options.length < 2) return;

              const opts = Array.from(select.options);
              const [placeholder, realOption] = opts;
              const isDummy = placeholder && /informational|select size/i.test(placeholder.textContent || '');
              const isReal = !!(realOption && (realOption.textContent || '').toLowerCase().includes('os'));

              if (isDummy) {
                placeholder.textContent = 'Select size';
                placeholder.disabled = true;

                if (isReal) {
                  placeholder.style.display = 'none';
                  select.value = realOption.value;
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                } else if (addButton) {
                  addButton.setAttribute('aria-disabled', 'true');
                  addButton.classList.add('disabled');
                  addButton.style.opacity = '0.5';
                  addButton.style.pointerEvents = 'none';
                }
              }

              const isRequired = product.getAttribute('data-mm-required') === 'true';
              if (isRequired) {
                const imgWrapper = product.querySelector('.bndlr-product-image-url');
                if (imgWrapper && !imgWrapper.querySelector('.bndlr-required-badge')) {
                  const badge = document.createElement('div');
                  badge.className = 'bndlr-required-badge';
                  badge.textContent = 'Required';
                  imgWrapper.appendChild(badge);
                }
              }

              const updateGroupAddToCart = () => {
                const parentBundle = product.closest('.bndlr-container, .bundle-grid, .bndlr-sectioned-available-products');
                const groupAddToCart = parentBundle?.querySelector('.bndlr-add-to-cart');
                if (groupAddToCart) {
                  const allSelects = parentBundle.querySelectorAll('select.bndlr-select-variant');
                  const allValid = Array.from(allSelects).every(sel => {
                    const opt = sel.options[sel.selectedIndex];
                    return opt && opt.value && !opt.disabled && !/select size/i.test(opt.textContent || '');
                  });
                  groupAddToCart.toggleAttribute('disabled', !allValid);
                  groupAddToCart.classList.toggle('disabled', !allValid);
                  groupAddToCart.style.opacity = allValid ? '1' : '0.5';
                  groupAddToCart.style.pointerEvents = allValid ? 'auto' : 'none';
                  groupAddToCart.setAttribute('aria-disabled', String(!allValid));
                }
              };

              select.addEventListener('change', () => {
                const selectedOption = select.options[select.selectedIndex];
                const isStillDummy = !selectedOption || selectedOption.disabled || !selectedOption.value || /select size/i.test(selectedOption.textContent || '');

                if (addButton) {
                  if (isStillDummy) {
                    addButton.setAttribute('aria-disabled', 'true');
                    addButton.classList.add('disabled');
                    addButton.style.opacity = '0.5';
                    addButton.style.pointerEvents = 'none';
                  } else {
                    addButton.removeAttribute('disabled');
                    addButton.classList.remove('disabled');
                    addButton.style.opacity = '1';
                    addButton.style.pointerEvents = 'auto';
                    addButton.setAttribute('aria-disabled', 'false');
                  }
                }

                updateGroupAddToCart();
              });

              updateGroupAddToCart();
            });
          });
        });
      });
    });
  });
})();
